<template>
    <footer class="pandora-footerv2" :style="{ background: props?.isdark ? '#272833' : '#F5F5F5' }">
        <input id="menu" type="checkbox" class="pandora-footerv2-switch" aria-label="Menú de navegación">
        <div class="pandoraContainerv2" :style="style" aria-label="Menú principal" role="navigation">
            <div class="logoPandorafv2">
                <PandoraLogo v-if="props?.logo" :isdark="props.isdark" />
            </div>
            <div v-for="(data, index) in columnlist" :key="index">
                <FooterCollapsible :key="'fc' + index" v-if="data?.title" :title="data?.title" :list="data?.list"
                    :isdark="props.isdark" />
                <div v-if="((columnlist?.length - 1) == index) && props?.socialmedia" role="contentinfo"
                    class="contentinfofv2">
                    <a href="">
                        <img :src="props?.isdark ? facebookLight : facebookDark" alt="facebook" width="25" height="25"
                            aria-label="Logo facebook" />
                    </a>
                    <a href="">
                        <img :src="props?.isdark ? twitterLight : twitterDark" alt="twitter" width="25" height="25"
                            aria-label="Logo twitter" />
                    </a>
                    <a href="">
                        <img :src="props?.isdark ? instagramLight : instagramDark" alt="instagram" width="25"
                            height="25" aria-label="Logo instagram" />
                    </a>
                    <a href="">
                        <img :src="props?.isdark ? linkedinLight : linkedinDark" alt="linkedin" width="25" height="25"
                            aria-label="Logo linkedin" />
                    </a>
                    <a href="">
                        <img :src="props?.isdark ? youtubeLight : youtubeDark" alt="youtube" width="25" height="25"
                            aria-label="Logo youtube" />
                    </a>
                </div>
            </div>
        </div>
        <p class="pandora-t-centerv2" :style="{ color: props?.isdark ? '#CDCED9' : '#7C7C7C' }"
            aria-label="Derechos de autor">Copyright © 2024 Aportes en Línea. Todos los
            derechos
            reservados.</p>
    </footer>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import '../../../assets/css/config.css'
import FooterCollapsible from './FooterCollapsible.vue';
import PandoraLogo from '../../logo/PandoraLogo.vue';

import facebookLight from '../../../assets/light/facebook.png';
import facebookDark from '../../../assets/dark/facebook.png';

import twitterLight from '../../../assets/light/twitter.png';
import twitterDark from '../../../assets/dark/twitter.png';

import instagramLight from '../../../assets/light/instagram.png';
import instagramDark from '../../../assets/dark/instagram.png';

import linkedinLight from '../../../assets/light/linkedin.png';
import linkedinDark from '../../../assets/dark/linkedin.png';

import youtubeLight from '../../../assets/light/youtube.png';
import youtubeDark from '../../../assets/dark/youtube.png';

const props = defineProps({
    columnSize: {
        type: Number,
        default: 4
    },
    isdark: {
        type: Boolean,
        default: false
    },
    logo: {
        type: Boolean,
        default: false
    },
    socialmedia: {
        type: Boolean,
        default: false
    },
    columnlist: {
        default: []
    }
});

const style = computed(() => {
    return `grid-template-columns: repeat(${props.columnSize}, 1fr)`
})
</script>

<style>
@media (max-width: 1033px) {
    .pandoraContainerv2 {
        grid-template-columns: repeat(1, 1fr) !important
    }

    .logoPandorafv2 {
        display: none;
    }
}

@media (min-width: 1033px) {
    .contentinfofv2 {
        text-align: left !important;
        margin-top: 5px !important;
    }
}

.logoPandorafv2 {
    width: 12rem;
}

.contentinfofv2 {
    margin-top: 20px;
    text-align: center;
}

.contentinfofv2 a {
    padding-inline: 12px;
}

.pandora-footerv2 li a {
    text-decoration: none;
    font-family: Rubik, sans-serif;
    font-size: 13px;
}

.pandora-footerv2 ul,
.pandora-footerv2 li {
    list-style: none !important;
    margin: 0;
    padding: 0;
}

.pandora-footerv2 li {
    padding-bottom: 20px;
}

.pandora-t-centerv2 {
    text-align: center;
    font-size: 14px;
    margin: 40px 0 0 0;
}

.pandoraContainerv2 {
    margin: auto;
    display: grid;
    grid-template-rows: 1fr;
}

.pandora-footerv2-switch {
    display: none;
}

.pandora-footerv2 {
    padding-inline: 3vw;
    padding-block: 5vh;
    position: relative;
    margin-top: -20px;
    z-index: 0;
    align-content: center;
}
</style>